import { render } from "./BudgetOverview.vue?vue&type=template&id=33aa28f4&scoped=true"
import script from "./BudgetOverview.vue?vue&type=script&lang=js"
export * from "./BudgetOverview.vue?vue&type=script&lang=js"

import "./BudgetOverview.vue?vue&type=style&index=0&id=33aa28f4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33aa28f4"]])

export default __exports__